import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-menu-item-button',
    templateUrl: './menu-item-button.component.html',
    styleUrls: ['./menu-item-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MenuItemButtonComponent {
    @Input()
    label: string = '';

    @Input()
    icon: string = '';

    @Input()
    svgIcon: string = '';

    @Input()
    disabled: boolean = false;

    @Input()
    showThreeDots: boolean = false;

    @Input()
    endIcon: string = '';

    @Input()
    endSvgIcon: string = '';

    @Output()
    onClick = new EventEmitter<any>();

    constructor() {}

    onClickButton(event): void {
        this.onClick.emit(event);
    }
}
